import type { ReactNode } from 'react';
import type { IconName } from '../Icons';

export type NoteStorage = 'localStorage' | 'sessionStorage';

export interface NoteProps {
  id: string;
  text: ReactNode;
  actions?: ReactNode;
  icon?: IconName;
  closable?: boolean;
  variant?: NoteVariant;
  onDismiss?: () => void;
  storage?: NoteStorage;
}

export const NoteVariant = {
  Default: 0,
  Positive: 1,
  Negative: 2,
  Warning: 3,
  Primary: 4,
  Announcement: 5,
} as const;
export type NoteVariant = (typeof NoteVariant)[keyof typeof NoteVariant];
